'use client';
import { atom, useAtom } from 'jotai';

export const creatorIdAtom = atom<string | null>(null);

export type UseCreatorIdResult = {
  atomCreatorId: string | null;
  setAtomCreatorId: (value: string | null) => void;
};
export const useCreatorId = (): UseCreatorIdResult => {
  const [creatorId, setCreatorId] = useAtom(creatorIdAtom);

  return {
    atomCreatorId: creatorId,
    setAtomCreatorId: setCreatorId,
  };
};
